import Css from './Css.js';
import VibrateBall from '../../Images/vibrator.png';
import orderUtil from '../../Utils/orderUtil.js';

function SlideBall(props){

  const {levelRange,editorMode,controlBallImgId,conBoxBottom} = props.data;
  let cbBottom = conBoxBottom;
  if(levelRange && levelRange.min >= 0){
    let selMin = orderUtil.oneLevelHeight*levelRange.min + orderUtil.coMinHeight;
    if(cbBottom < selMin){
      cbBottom = selMin;
    }
    let selMax = orderUtil.coMaxHeight - orderUtil.oneLevelHeight*(20 - levelRange.max);
    if(cbBottom > selMax){
      cbBottom = selMax;
    }
  }
  if(cbBottom <= orderUtil.coMinHeight){
    cbBottom = orderUtil.coMinHeight;
  }

  return (
    <>
      <div id={controlBallImgId} style={ Css.SlideBall(cbBottom) }>
        <div style={ Css.splitLine }></div>
        <img style={ Css.imgBall(editorMode) } src={ VibrateBall } alt=""
          onMouseDown={ (e)=>{ props.onMouseDownEvent(e) } }
          onMouseUp={ (e)=>{ props.onMouseUpEvent(e) } }
        />
      </div>
    </>
  )
}

export default SlideBall;